import { Directive, ElementRef, HostListener, inject, input, output } from '@angular/core';

@Directive({
  selector: '[appClickOutside]',
})
export class ClickOutsideDirective {
  readonly elementVisible = input.required<boolean>();
  readonly clickOutside = output();

  // DI
  private readonly el = inject<ElementRef<HTMLElement>>(ElementRef);

  constructor() {}

  @HostListener('document:mousedown', ['$event'])
  onMouseDown(event: MouseEvent): void {
    if (!this.el.nativeElement.contains(event.target as Node) && this.elementVisible()) {
      this.clickOutside.emit();
    }
  }
}
